import { render, staticRenderFns } from "./CategoryDraggable.vue?vue&type=template&id=494d057f&scoped=true&"
import script from "./CategoryDraggable.vue?vue&type=script&lang=js&"
export * from "./CategoryDraggable.vue?vue&type=script&lang=js&"
import style0 from "./CategoryDraggable.vue?vue&type=style&index=0&id=494d057f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d057f",
  null
  
)

export default component.exports